// extracted by extract-css-chunks-webpack-plugin
module.exports = {"search_box":"search_box-1JgaPMns","text":"text-30xLXN-g","btn":"btn-54sS6eA0","search":"search-2MrRHvQJ"};